<template>
  <div class="content">
    <div class="content-title" v-if="!allCar">{{ title }}</div>
    <div class="content-tagbox" v-if="!allCar">
      <el-tag
        v-for="item in vechicles"
        closable
        :key="item.id"
        @close="removeVechicle(item)"
        >{{ item.plateNoOrVin }}</el-tag
      >
    </div>
    <el-form :model="formData" ref="formRef" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <DeptSelector
            v-model="formData.deptId"
            label="将车辆调整至"
            prop="deptId"
            :isAll="true"
            :multiple="false"
          />
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script setup>
import { ref, reactive, computed } from 'vue'
import DeptSelector from '@/components/DeptSelect/WithLabel.vue'

const props = defineProps({
  vechicles: {
    type: Array,
    default: () => [],
  },
  allCar: {
    type: Boolean,
    default: () => false,
  },
})
const emits = defineEmits(['update:vechicles'])

// 表单数据
const formRef = ref(null)
const formData = reactive({ deptId: '' })
const rules = reactive({
  deptId: [{ required: true, message: '请选择部门', trigger: 'blur' }],
})
// 车辆信息
const title = computed(() => `车辆（共 ${props.vechicles.length} 辆）`)

// 移除车辆
const removeVechicle = (vechicle) => {
  emits('update:vechicles', props.vechicles.filter((item) => item.id !== vechicle.id))
}

const validate = () => {
  return new Promise((resolve) => {
    formRef.value.validate((valid) => {
      if (valid) {
        resolve(formData.deptId)
      }
      resolve(null)
    })
  })
}

defineExpose({
  validate,
})

</script>

<style scoped lang="scss">
::v-deep(.el-select--small) {
  width: 100% !important;
}
::v-deep(.el-form-item .el-form-item__label) {
  justify-content: flex-start;
}
::v-deep(.el-tag--small) {
  padding: 2px 8px;
  font-size: 14px;
  font-weight: normal;
  height: 24px;
  margin-bottom: 8px;
  margin-right: 8px;
}

.content {
  width: 100%;
  height: 100%;
  > .content-tagbox {
    margin-top: 8px;
    overflow: auto;
    max-height: calc(100% - 126px);
  }
}
</style>
